<template>
  <div ref="tag" @click="handleTag" :class="{ active: active }" class="tag">
    {{ tag.name }}
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      default: () => ({}),
    },
    active: Boolean,
    index: {
      type: Number,
      default: 0,
    },
    isLinks: Boolean,
    category: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      type: 'desktop',
    }
  },
  watch: {
    active (prev) {
      if (prev === true) {
        this.$emit('scroll-to-el', this.$refs.tag.offsetLeft)
      }
    },
  },
  methods: {
    handleTag () {
      if (!this.isLinks) {
        const data = {
          index: this.index,
          collectionId: this.tag.id,
          target: this.tag.target,
          type: this.type,
        }
        this.$emit('remote-check-tag', data)
      } else {
        this.$router.push({
          name: 'menu-name',
          params: {
            category: this.tag.target,
            collectionId: this.tag.id,
          },
        })
      }
    },
  },
}
</script>

<style lang="less">
	.tag {
		height: 36px;
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		background-color: #f5f5f5;
		border-radius: 10px;
		padding: 0 30px;
		margin-bottom: 18px;
		font-family: 'Roboto', Arial, sans-serif;
		font-size: 14px;
		color: black;
		text-decoration: none;
		transition: all 0.2s;
		cursor: pointer;

		@media screen and (max-width: 768px) {
			margin-bottom: 23px;
		}

		&:not(:last-child) {
			margin-right: 30px;

			@media screen and (max-width: 768px) {
				margin-right: 10px;
			}
		}

		&.active {
			color: white;
      background-color: #E31E24;

			/*&:nth-child(4n + 1) {
				background-color: #3600ff;
			}

			&:nth-child(4n + 2) {
				background-color: #ff9800;
			}

			&:nth-child(4n + 3) {
				background-color: #8800ff;
			}

			&:nth-child(4n + 4) {
				background-color: #ff005f;
			}*/
		}

		&_group {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
		}
	}

	@media (max-width: 1024px) {
		.tag:hover,
		.tag:focus {
			background-color: #f5f5f5;
		}
	}

	@media (min-width: 1025px) {
		.tag {
			&.active,
			&:hover,
			&:focus {
				color: white;
        background-color: #E31E24;

				/*&:nth-child(4n + 1) {
					background-color: #3600ff;
				}

				&:nth-child(4n + 2) {
					background-color: #ff9800;
				}

				&:nth-child(4n + 3) {
					background-color: #8800ff;
				}

				&:nth-child(4n + 4) {
					background-color: #ff005f;
				}*/
			}
		}
	}
</style>
